import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div<{ isModal?: boolean }>`
  margin-left: ${({ isModal }) => (isModal ? 0 : 16)}px;
  margin-top: ${({ isModal }) => (isModal ? 16 : 0)}px;
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${device.mobileMax} {
    margin-bottom: 24px;
  }
`

export const Title = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  color: ${colors.mainText};
`

export const RespondedContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RespondedRating = styled.div`
  display: flex;
  margin-top: 1px;
  width: 68px;
`

export const RespondedFeedbackRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`

export const RespondedFeedback = styled.span``

export const RespondedIcon = styled.div`
  display: flex;
  margin-right: 8px;
  width: 16px;
  height: 16px;
`

export const ResponsePlaceholder = styled.span<{ isModal?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.messegesYellow1};
`
